"use client";

import { useEffect } from "react";

export default function InjectSessionPageSiblings({
  id,
  slugs,
}: {
  id?: string;
  slugs?: string;
}) {
  useEffect(() => {
    if (id) {
      window.sessionStorage.setItem("siblings", `product:${id}`);
    } else if (slugs) {
      window.sessionStorage.setItem("siblings", slugs);
    }
    return () => window.sessionStorage.removeItem("siblings");
  }, [id, slugs]);

  return null;
}
